import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import styles from "../../../../src/content/media-ministries/styles";
import "../../../../src/content/media-ministries/media-ministries.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  styles,
  React
};